import { string, object, number, array, bool, mixed } from "yup";

export const EmptyForm = {
    candidate: {
        name: "",
        company: "",
        url: "",
        orgSize: "",
        member: "",
    },
    submitter: {
        name: "",
        email: "",
        phone: "",
    },
    invoice: {
        name: "",
        address: {
            street: "",
            postalCode: "",
            city: "",
        },
        nip: "",
    },
    agreements: {
        notifyAboutCompetition: false,
        notifyAboutOtherActivities: false,
        termsAndConditions: false,
        // dataAutenticity: false,
        // releaseImage: false,
    },
    logo: {
        vector: null, // cdr, eps, ai, psd
        raster: null, // png, jpeg
    },
    submissions: [],
};

export const EmptySubmission = {
    key: -1,
    category: "",
    title: "",
    description: "",
    teamSize: undefined,
    duties: "",
    teamLeads: "",
    presentation: null, // pdf
};

export const Categories = [
    "zespół e-commerce (podmioty małe i średnie)",
    "zespół e-commerce (podmioty duże)",
    "zespół e-commerce B2B",
];

export const FormSchema = object().shape({
    candidate: object()
        .shape({
            name: string().required(),
            company: string().required(),
            url: string().required(),
            orgSize: string().required().oneOf(["mały", "średni-duży"]),
            member: string().required().oneOf(["tak", "nie"]),
        })
        .required(),
    submitter: object()
        .shape({
            name: string().required(),
            email: string().required().email(),
            phone: string().required(),
        })
        .required(),
    invoice: object()
        .shape({
            name: string().required(),
            address: object().shape({
                street: string().required(),
                postalCode: string()
                    .required()
                    .matches(/^\d{2}-\d{3}$/),
                city: string().required(),
            }),
            nip: string()
                .required()
                .matches(/^\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})$/),
        })
        .required(),
    agreements: object()
        .shape({
            notifyAboutCompetition: bool().required().oneOf([true]),
            notifyAboutOtherActivities: bool(),
            termsAndConditions: bool().required().oneOf([true]),
            // dataAuthenticity: bool().required().oneOf([true]),
            // releaseImage: bool().required().oneOf([true]),
        })
        .required(),
    logo: object()
        .shape({
            vector: mixed().required(), // todo:
            // raster: mixed().required(), // todo:
        })
        .required(),
    submissions: array()
        .of(
            object().shape({
                key: number().required(),
                category: string().required().oneOf(Categories),
                title: string().required(),
                description: string().required().min(10).max(1000),
                presentation: mixed().required(), // todo:
                teamSize: number().required().min(1).max(100),
                duties: string().required().max(1000),
                teamLeads: string().required(),
            })
        )
        .required()
        .min(1)
        .max(3),
});
